import * as React from 'react';
import { cn } from '@/lib/utils';

export interface CDPageContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  pageNumber: number;
  totalPages: number;
  formId?: string;
  children: React.ReactNode;
}

/**
 * CDPageContainer - Page wrapper for Closing Disclosure pages
 *
 * Provides:
 * - 8.5" x 11" page dimensions
 * - 0.5" margins
 * - Page header with form ID
 * - Page footer with page numbers
 * - Print-optimized layout with page breaks
 */
export const CDPageContainer = React.forwardRef<HTMLDivElement, CDPageContainerProps>(
  ({ pageNumber, totalPages, formId, children, className, ...props }, ref) => {
    return (
      <div ref={ref} className={cn('cd-page', className)} data-page={pageNumber} {...props}>
        <div className="cd-page-content">{children}</div>
        <div className="cd-page-footer">
          <span>{formId || 'CLOSING DISCLOSURE'}</span>
          <span>
            PAGE {pageNumber} OF {totalPages}
          </span>
        </div>
      </div>
    );
  },
);

CDPageContainer.displayName = 'CDPageContainer';
